import type { IWidgetModelTypesWebSource } from "app/components/widget/widget-types/Widget";
import { useSearchAdvertisingDataAndParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useSearchAdvertisingDataAndParams";
import { useAddToDashboard } from "app/components/dashboard/AddToDashboard/useAddToDashboard";
import {
    createVolumeFilter,
    getRangeFilterQueryParamValue,
    createCpcFilter,
} from "pro-features/components/filtersPanel/src/RangeFilterUtilityFunctions";

import { DASHBOARD_TYPE, SourceTypeMap } from "app/common/keyword-research/website-keywords/tableConsts";

export const useWebsiteKeywordsPage2TableDashboard = () => {
    const {
        webSource,
        duration,
        country,
        selectedPageTab,
        volumeToValue,
        volumeFromValue,
        cpcFromValue,
        cpcToValue,
        trafficPreset,
        ...addToDashboardParams
    } = useSearchAdvertisingDataAndParams();

    const rangeFilter = getRangeFilterQueryParamValue([
        createVolumeFilter(volumeFromValue, volumeToValue, "volume"),
        createCpcFilter(cpcFromValue, cpcToValue, "cpc"),
    ]);

    const filtersParams = {
        ...addToDashboardParams,
        rangeFilter,
        cpcFromValue,
        cpcToValue,
        volumeFromValue,
        volumeToValue,
        sourceType: SourceTypeMap[selectedPageTab],
        trafficPreset,
    };

    return useAddToDashboard({
        metric: DASHBOARD_TYPE,
        type: DASHBOARD_TYPE,
        modelType: "fromWebsite",
        webSource: webSource as IWidgetModelTypesWebSource,
        duration,
        country: country.toString(),
        filters: filtersParams,
    });
};
